import React from 'react';
import styles from './styles.module.scss';

const CustomLoader = () => {
  return (
    <div className={styles.loader_container}>
      <div className={styles.loader}></div>
    </div>
  );
};

export default CustomLoader;
